import React from 'react';
import { Container } from '../components/Container';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter, ShieldCheck } from 'lucide-react';
export function Contact() {
  return <div className="w-full bg-white" data-id="element-348">
      {/* Header */}
      <div className="bg-[#111827] text-white py-16" data-id="element-349">
        <Container data-id="element-350">
          <div className="max-w-3xl" data-id="element-351">
            <h1 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4" data-id="element-352">
              Contact Us
            </h1>
            <div className="w-20 h-1.5 bg-pts-red mb-6" data-id="element-353"></div>
            <p className="text-xl text-gray-300" data-id="element-354">
              Have a question, need a quote, or ready to start an order? Our
              team is here to help.
            </p>
          </div>
        </Container>
      </div>

      {/* Quote Callout Band */}
      <div className="bg-pts-red text-white py-4" data-id="element-355">
        <Container data-id="element-356">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-4" data-id="element-357">
            <ShieldCheck className="h-6 w-6 flex-shrink-0" data-id="element-358" />
            <div data-id="element-359">
              <span className="font-oswald text-xl font-bold uppercase tracking-wide mr-2" data-id="element-360">
                Send Us Your Quote.
              </span>
              <span className="text-white/90 font-medium" data-id="element-361">
                Email your current quote to savemoney@getcustomuniforms.com and
                we'll beat it.
              </span>
            </div>
          </div>
        </Container>
      </div>

      <Container className="py-20" data-id="element-362">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-363">
          {/* Left Column: Form */}
          <div className="lg:w-2/3" data-id="element-364">
            <h2 className="font-oswald text-3xl font-bold uppercase text-gray-900 mb-6" data-id="element-365">
              Send a Message
            </h2>
            <form className="space-y-6 bg-gray-50 p-8 rounded-xl border border-gray-200" onSubmit={e => e.preventDefault()} data-id="element-366">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-367">
                <div data-id="element-368">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-369">
                    First Name *
                  </label>
                  <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-370" />
                </div>
                <div data-id="element-371">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-372">
                    Last Name *
                  </label>
                  <input type="text" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-373" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-374">
                <div data-id="element-375">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-376">
                    Email Address *
                  </label>
                  <input type="email" required className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-377" />
                </div>
                <div data-id="element-378">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-379">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-380" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-381">
                <div data-id="element-382">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-383">
                    Organization / Team Name
                  </label>
                  <input type="text" className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-384" />
                </div>
                <div data-id="element-385">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-386">
                    Sport
                  </label>
                  <select className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white" data-id="element-387">
                    <option data-id="element-388">Select a Sport</option>
                    <option data-id="element-389">Baseball</option>
                    <option data-id="element-390">Basketball</option>
                    <option data-id="element-391">Football</option>
                    <option data-id="element-392">Softball</option>
                    <option data-id="element-393">Soccer</option>
                    <option data-id="element-394">Cheer</option>
                    <option data-id="element-395">Volleyball</option>
                    <option data-id="element-396">Track & Field</option>
                    <option data-id="element-397">Other / Groupwear</option>
                  </select>
                </div>
              </div>

              <div data-id="element-398">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-399">
                  Message *
                </label>
                <textarea required rows={5} className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:ring-pts-red focus:border-pts-red outline-none bg-white resize-none" placeholder="How can we help you?" data-id="element-400"></textarea>
              </div>

              <div className="pt-2" data-id="element-401">
                <button type="submit" className="bg-pts-red hover:bg-pts-red-dark text-white px-8 py-3 rounded font-bold uppercase tracking-wide transition-colors" data-id="element-402">
                  Send Message
                </button>
                <p className="text-sm text-gray-500 mt-4" data-id="element-403">
                  Note: If you have a quote or artwork files to attach, please
                  email them directly to{' '}
                  <a href="mailto:savemoney@getcustomuniforms.com" className="text-pts-red hover:underline" data-id="element-404">
                    savemoney@getcustomuniforms.com
                  </a>
                  .
                </p>
              </div>
            </form>
          </div>

          {/* Right Column: Info */}
          <div className="lg:w-1/3" data-id="element-405">
            <div className="bg-[#111827] text-white rounded-xl p-8 shadow-lg sticky top-28" data-id="element-406">
              <h3 className="font-oswald text-2xl font-bold uppercase mb-6 border-b border-gray-700 pb-4" data-id="element-407">
                Contact Information
              </h3>

              <div className="space-y-6" data-id="element-408">
                <div className="flex items-start" data-id="element-409">
                  <Phone className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-410" />
                  <div data-id="element-411">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-412">
                      Phone
                    </h4>
                    <a href="tel:8882188647" className="text-lg font-bold hover:text-pts-red transition-colors" data-id="element-413">
                      888.218.8647
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-414">
                  <Mail className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-415" />
                  <div data-id="element-416">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-417">
                      Sales & Quotes
                    </h4>
                    <a href="mailto:savemoney@getcustomuniforms.com" className="hover:text-pts-red transition-colors break-all" data-id="element-418">
                      savemoney@getcustomuniforms.com
                    </a>

                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mt-3 mb-1" data-id="element-419">
                      Support
                    </h4>
                    <a href="mailto:support@getcustomuniforms.com" className="hover:text-pts-red transition-colors break-all" data-id="element-420">
                      support@getcustomuniforms.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-421">
                  <MapPin className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-422" />
                  <div data-id="element-423">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-424">
                      Address
                    </h4>
                    <p className="text-gray-300" data-id="element-425">
                      Primetime Sports Apparel
                      <br data-id="element-426" />
                      9229 Southampton Place
                      <br data-id="element-427" />
                      Boca Raton, Florida 33434
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-428">
                  <Clock className="h-6 w-6 text-pts-red mr-4 flex-shrink-0" data-id="element-429" />
                  <div data-id="element-430">
                    <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-1" data-id="element-431">
                      Hours
                    </h4>
                    <p className="text-gray-300" data-id="element-432">
                      Monday – Friday
                      <br data-id="element-433" />
                      9:00 AM – 7:00 PM EST
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-6 border-t border-gray-700" data-id="element-434">
                <h4 className="font-bold text-sm text-gray-400 uppercase tracking-wider mb-4" data-id="element-435">
                  Follow Us
                </h4>
                <div className="flex space-x-4" data-id="element-436">
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-437">
                    <Facebook className="h-5 w-5" data-id="element-438" />
                  </a>
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-439">
                    <Instagram className="h-5 w-5" data-id="element-440" />
                  </a>
                  <a href="#" className="bg-gray-800 p-2.5 rounded hover:bg-pts-red transition-colors" data-id="element-441">
                    <Twitter className="h-5 w-5" data-id="element-442" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>;
}